import { FC } from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { Car } from '@one-thd/sui-icons';
import { pushEventInfo } from '../../utils/analytics';

interface ICurbsidePickup {
  orderId: string;
  storeId: string;
}

export const CurbsidePickup: FC<ICurbsidePickup> = ({ orderId, storeId }) => {
  const handleCurbsideClick = () => {
    // Analytics Event Push
    pushEventInfo({
      category: { primaryCategory: 'button submission' },
      eventInfo: { eventName: 'Curbside Pickup' },
      myAccount: { settings: 'Curbside Pickup button clicked' },
    });

    // Trigger Native App Event
    if (window?.LIFE_CYCLE_EVENT_BUS?.trigger) {
      window.LIFE_CYCLE_EVENT_BUS.trigger('NATIVE_APP.OPEN_CURBSIDE', {
        storeId,
        orderId,
      });
    }
  };

  return (
    <Button
      startIcon={Car}
      onClick={handleCurbsideClick}
      data-testid="curbside-pickup-button"
      fullWidth
    >
      Get it Curbside
    </Button>
  );
};
